import { ChangeDetectorRef, Component, HostListener, ViewChild } from '@angular/core';
import { PrimaryButtonComponent } from "../../../../../shared/components/primary-button/primary-button.component";
import { UploadedFileComponent } from "../uploaded-file/uploaded-file.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { UploadedFile } from '../../../../../core/interfaces/file-upload-interfaces';
import { ToastComponent } from '../../../../../shared/components/toast/toast.component';
import { ReplaceFileDialogComponent } from '../../../../file-upload/components/dialogs/replace-file-dialog/replace-file-dialog.component';
import { RecentUploadsService } from '../../../../../core/services/recent-uploads.service';
import { CommonModule } from '@angular/common';
import { AddNewLocationDialogComponent } from "../../../../locations/components/dialogs/add-new-location-dialog/add-new-location-dialog.component";
import { LocationFileUploadComponent } from "../../../../file-upload/components/location-file-upload/location-file-upload.component";

@Component({
  selector: 'app-onboarding-step-four-upload',
  standalone: true,
  imports: [PrimaryButtonComponent, UploadedFileComponent, TranslocoPipe, CommonModule, ToastComponent, ReplaceFileDialogComponent, AddNewLocationDialogComponent, LocationFileUploadComponent],
  templateUrl: './onboarding-step-four-upload.component.html',
  styleUrl: './onboarding-step-four-upload.component.css'
})
export class OnboardingStepFourUploadComponent {

  get listOfRecentUploads(): UploadedFile[] {
    return this.recentUploads.getLastUploads(10);
  }

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Add location data dialog
  @ViewChild(AddNewLocationDialogComponent) addLocationDataDialog!: AddNewLocationDialogComponent;

  constructor(private cdRef: ChangeDetectorRef, private translocoService: TranslocoService, private recentUploads: RecentUploadsService) { }

  ngOnInit(): void {
    this.cdRef.detectChanges();
  }

  stopClicked(id: number) {
    if (!this.recentUploads.stopUpload(id)) {
      return;
    }

    this.toast.showToast(this.translocoService.translate("shared.file_upload.canceled"), this.translocoService.translate("shared.file_upload.stopped"), "warning", 4000, false);

  }

  openAddLocationDataDialog = () => {
    this.addLocationDataDialog.openModal();
  }
}
